import React from 'react';

import styled from 'styled-components';

import useMediaQuery from 'hooks/use-media-query';
import { useLocationContext } from 'state/location';
import { useOrderContext } from 'state/order';
import { getAllLocalizedVersionsOfRoute, routes } from 'utils/routing';

import DesktopHeader from './desktop-header';
import MobileHeader from './mobile-header';

const BannerHeader = styled.header`
  display: flex;
  flex-direction: column;
`;

export const routesWithoutHeader = [
  routes.cart,
  ...getAllLocalizedVersionsOfRoute('signIn'),
  ...getAllLocalizedVersionsOfRoute('signUp'),
  routes.orderConfirmation,
  ...getAllLocalizedVersionsOfRoute('hockeyChallenge'),
];

const routesWithoutMobileHeader = [
  ...getAllLocalizedVersionsOfRoute('hockeyChallenge'),
  ...getAllLocalizedVersionsOfRoute('storeLocator'),
  routes.cateringStoreLocator,
];

const isPathInRouteList = (routeList: string[], pathname: string) =>
  routeList.some(route => pathname.startsWith(route));

const AppHeader: React.FC = () => {
  const { serviceMode, cateringPickupDateTime, deliveryAddress } = useOrderContext();
  const isMobile = useMediaQuery('mobile');

  const {
    location: { pathname },
  } = useLocationContext();

  if (
    (isMobile && isPathInRouteList(routesWithoutMobileHeader, pathname)) ||
    (!isMobile && isPathInRouteList(routesWithoutHeader, pathname))
  ) {
    return null;
  }

  return (
    <BannerHeader role="banner">
      {isMobile && (
        <MobileHeader
          serviceMode={serviceMode}
          userAddress={deliveryAddress?.addressLine1}
          cateringPickupDateTime={cateringPickupDateTime}
        />
      )}
      {!isMobile && (
        <DesktopHeader
          serviceMode={serviceMode}
          userAddress={deliveryAddress?.addressLine1}
          cateringPickupDateTime={cateringPickupDateTime}
        />
      )}
    </BannerHeader>
  );
};

export default AppHeader;
export { default as LogoHeader } from './logo-header';
export { default as MenuHeader, HEADER_HEIGHT } from './menu-header';
